import React, { useEffect, useState, useMemo } from "react";

import NoDataFound from "../common/NoDataFound";
import RugbyLineupBox from "./RugbyLineupBox";
import { loadStyles } from "../../utils/cssLoader";

const RugbyLineup = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);

  const data = useMemo(() => (dataClient ? clientData : ServerData), [clientData, ServerData, dataClient]);

  const homeLineups = data?.data?.home_team?.lineup || [];
  const awayLineups = data?.data?.away_team?.lineup || [];
  const homeSubs = data?.data?.home_team?.substitutions || [];
  const awaySubs = data?.data?.away_team?.substitutions || [];

  useEffect(() => {
    if (!dataClient) return;

    try {
      const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
      if (!raw) return;

      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed ?? null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("rugby");
    }
  }, [loadCSS]);

  const hasLineups = homeLineups.length > 0 || awayLineups.length > 0;
  const hasSubs = homeSubs.length > 0 || awaySubs.length > 0;

  return (
    <>
      {title && <h1>{title}</h1>}

      {data?.data ? (
        <div className="markets_box_wrp">
          {hasLineups && (
            <RugbyLineupBox
              home={homeLineups}
              away={awayLineups}
              title="Starting Lineups"
            />
          )}
          {hasSubs && (
            <RugbyLineupBox
              home={homeSubs}
              away={awaySubs}
              title="Substitutes"
            />
          )}
        </div>
      ) : (
        <NoDataFound />
      )}
    </>
  );
};

export default RugbyLineup;
